export const REFERENCE_WIDTH = 320;

// Grid configuration
export const VISIBLE_GRID_WIDTH = 12;
export const VISIBLE_GRID_HEIGHT = 12;

// Computed grid cell size (use smaller dimension to keep square cells)
export const GRID_CELL_SIZE = Math.floor(REFERENCE_WIDTH / 13.714); // 12 / 0.875 (long story)

// Player constants
export const PLAYER_START_X = 0;
export const PLAYER_START_Y = 0;
export const PLAYER_HORIZONTAL_POSITION = 3; // Player stays at x=3 on screen (visually)
export const PLAYER_SIZE = GRID_CELL_SIZE * 0.95;

// Game physics constants
export const GRAVITY = -2000; // Gravity acceleration per second (negative = down)
export const JUMP_FORCE = 510;
export const PLAYER_SPEED = 12; // How fast world scrolls (grid units per second)
export const JUMP_ROTATION_DEGREES = 90;
export const ROTATION_SPEED = 360;
export const GROUND_LEVEL = 1;

// Jump feel constants
export const COYOTE_TIME = 0.03; // Seconds after leaving ground where jump is still allowed
export const JUMP_BUFFER_TIME = 0.1; // Seconds to buffer a jump input before landing

// Camera constants
export const CAMERA_SMOOTHING = 0.05;
export const CAMERA_DEADZONE_TOP = 2; // Grid units from top before camera moves
export const CAMERA_DEADZONE_BOTTOM = 2; // Grid units from bottom before camera moves

export const PLAYER_COLOR = [120, 180, 255] as const;
export const PLATFORM_COLOR = [60, 120, 140] as const;
export const SPIKE_COLOR = [40, 30, 70] as const;
export const GROUND_COLOR = [20, 70, 120] as const;
export const BACKGROUND_COLOR = [10, 30, 50] as const;
export const ACCENT_COLOR = [160, 220, 255] as const;

// Lamp constants
export const LAMP_FREQUENCY = 0.33; // Odds of a platform having a lamp
export const LAMP_OPACITY_MIN = 0.5;
export const LAMP_OPACITY_MAX = 0.8;
export const LAMP_SCALE_MIN = 0.8;
export const LAMP_SCALE_MAX = 1.2;

export const BACKGROUND_SCALE_X = 8;
export const BACKGROUND_SCALE_Y = 2;
export const BACKGROUND_OFFSET_X_RATIO = 1 / 6;
export const BACKGROUND_OFFSET_Y_RATIO = 1 / 4;
export const MASONRY_GRID_SIZE = 30;
export const MASONRY_GAP = 10;
export const MASONRY_SQUARE_SIZES = [40, 60, 80, 100, 120] as const;
export const MASONRY_ATTEMPTS = 2000;

export const MASONRY_COLORS = [
  [70, 70, 80] as const,
  [80, 80, 90] as const,
  [90, 90, 100] as const,
  [75, 75, 85] as const,
  [85, 85, 95] as const,
] as const;

export const OUTLINE_THICKNESS = 0.075;
export const GRID_TEXTURE_SCALE = 8;
export const GROUND_EDGE_WIDTH_OFFSET = 4;
export const GROUND_EDGE_HEIGHT = 2;
export const GROUND_EDGE_POSITION_OFFSET = 2;

export const LAMP_POST_WIDTH = 4;
export const LAMP_POST_HEIGHT_RATIO = 1.5;
export const LAMP_POST_OFFSET_Y = 0.75;
export const LAMP_LIGHT_RADIUS = 8;
export const LAMP_LIGHT_OFFSET_Y = 1.5;

export const SPIKE_INSET_SIZE = 2;

// Audio constants
export const BACKGROUND_MUSIC_VOLUME = 0.3;
export const DEATH_SOUND_VOLUME = 0.5;

// Game constants
export const BACKGROUND_PARALLAX_SPEED = 0.2; // How much slower background moves than world
export const MAX_SCORE = 10_000; // Maximum possible score

// Debug constants
export const DEBUG_LAMP_AT_START = false; // Add a debug lamp at level start and freeze the player for beat testing
